import React from 'react';
import { FiDownload, FiShare2, FiHeart, FiRefreshCw } from 'react-icons/fi';
import { motion } from 'framer-motion';

const QuickActions = ({ 
  onExport, 
  onShare, 
  onSaveFavorite, 
  onRefresh,
  isFavorite = false 
}) => {
  const actions = [
    { icon: FiRefreshCw, label: 'Actualiser', onClick: onRefresh, color: 'text-blue-400' },
    { icon: FiDownload, label: 'Exporter', onClick: onExport, color: 'text-green-400' },
    { icon: FiShare2, label: 'Partager', onClick: onShare, color: 'text-purple-400' },
    { 
      icon: FiHeart, 
      label: isFavorite ? 'Retirer des favoris' : 'Sauvegarder', 
      onClick: onSaveFavorite, 
      color: isFavorite ? 'text-red-400' : 'text-gray-400'
    }
  ];

  return (
    <div className="flex items-center gap-2">
      {actions.map((action, index) => {
        const Icon = action.icon;
        return (
          <motion.button
            key={index}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={action.onClick}
            className={`p-2 rounded-lg bg-gray-800/50 border border-gray-700 hover:border-gray-600 transition-colors ${action.color} hover:bg-gray-700`}
            title={action.label}
          >
            <Icon className="w-5 h-5" />
          </motion.button>
        );
      })}
    </div>
  );
};

export default QuickActions;





